import styled from "styled-components";
import { transparentize, lighten } from "polished";

import theme from "config/theme";

import { H3 } from "components/Text";

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 0 35px;

  @media (max-width: ${theme.size.tablet}) {
    padding: 0 0 15px;
    flex-direction: column;
  }
`;

export const Heading = styled(H3)`
  margin-bottom: 0;
  color: white;

  p {
    margin: 0;
  }

  @media (max-width: ${theme.size.tablet}) {
    max-width: 100%;
    margin-bottom: 10px;
  }
`;

export const Inner = styled.div`
  position: relative;
  text-align: center;
  margin-left: -30px;
  width: calc(100% + 60px);
  min-height: 400px;
  padding-bottom: 15px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    height: 100%;
    width: 50px;
    z-index: 2;

    @media (max-width: ${theme.size.mobile}) {
      width: 40px;
    }
  }

  &::before {
    left: 0;
    background: linear-gradient(
      to left,
      ${transparentize(1, lighten(0.03, theme.color.gray))} 0%,
      ${transparentize(0.1, lighten(0.03, theme.color.gray))} 100%
    );
  }

  &::after {
    right: 0;
    background: linear-gradient(
      to right,
      ${transparentize(1, lighten(0.03, theme.color.gray))} 0%,
      ${transparentize(0.1, lighten(0.03, theme.color.gray))} 100%
    );
  }

  @media (max-width: ${theme.size.desktop}) {
    margin-left: -40px;
    width: calc(100% + 80px);
  }

  @media (max-width: ${theme.size.tablet}) {
    margin-left: -30px;
    width: calc(100% + 60px);
  }

  .slick-slide {
    width: 360px !important;

    @media (max-width: ${theme.size.mobile}) {
      width: 320px !important;
    }
  }
`;
